import { Provider } from 'react-redux';
import './App.css';
import AllBlogs from './components/allBlogs/AllBlogs';
import Navbar from './components/navbar/Navbar';
import SearchBar from './components/searchBar/SearchBar';
import store from './redux/store';

function App() {
  return (
    <Provider store={store}>
      <div>
        {/* <!-- navigation --> */}
        <Navbar />

        {/* <!-- search --> */}
        <SearchBar />

        <AllBlogs />

        {/* <!-- footer --> */}
        <section className="pt-6">
          <div
            className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex justify-between gap-2 border-t text-sm text-slate-400"
          >
            <div>Copyright 2022 Learn with Sumit.</div>
            <div>
              <a
                href="https://youtube.com/learnwithsumit"
                target="_blank"
                rel="noreferrer"
              >
                YouTube Channel
              </a>
            </div>
          </div>
        </section>
      </div>
    </Provider>
  );
}

export default App;
